import type { ReactNode } from "react";
import "./FlatSelectMultiItem.scss";
import Checkbox from "@/shared/components/generic/checkbox/Checkbox.tsx";
import { Size } from "@/shared/components/generic/UiEnums.ts";

interface Properties {
  label: string;
  selected: boolean;
  onSelect: () => void;
}

export default function FlatSelectMultiItem(props: Properties): ReactNode {
  return (
    <div className="flat-select-multi-item" onClick={props.onSelect}>
      <Checkbox
        selected={props.selected}
        onChange={props.onSelect}
        size={Size.XSMALL}
        item={{ key: "foo", label: "" }}
      />
      <div>{props.label}</div>
    </div>
  );
}
